function showWords()
{
  console.log('showWords called');
  //STANDARD
  document.getElementById("cross").style.display = "none";//hide fixation cross
  showTrialInfo();//only displays if selected
  showTimer();

  var wordFontSize = '2em';
  if (columnForTrial('stimSize', trialRow) !== 'na') {
    wordFontSize = listStimSizeFunctions[trialRow][0].size;
  }

  stimContainers[0] = document.getElementById("wordTarget");
  for (var i = 1; i <= window.stimFieldsMax; i++)
  {
    stimContainers[i] = document.getElementById('word'+i);
    stimContainers[i].style.fontSize = wordFontSize;
  }
  trialTextContainer = document.getElementById("trialText");

  //FORMAT & enable clicks if no keyboard or buttons are set
  for (var i = 1; i <= window.stimFieldsMax; i++) {
    if ((listNoStim[trialRow] > 0 || listNoStimS2[trialRow] > 0)
      && (window.columnForTrial('type', window.trialRow)=="test" || window.columnForTrial('type', window.trialRow)=="practice")
      && window.columnForTrial('keyboard', window.trialRow)=="na"
      && window.columnForTrial('button1', window.trialRow)=="na"
      && (window.columnForTrial('responseType', window.trialRow)=="na" || window.columnForTrial('responseType', window.trialRow) == "clicks"))
    //if responses are recorded via keyboard or buttons
    {
      enableWordClicks(i);
    } else {

      disableWordClicks(i);
    }

    let wordContent = getStimForTrialRow(trialRow, i - 1);
    if(!wordContent) {
      continue;
    }
    wordContent = replaceVariables(wordContent, undefined, undefined, undefined, 1);
    stimContainers[i].innerHTML = wordContent;
    applyStimCssOption(trialRow, i);
  }

  // TARGET
  let targetContent = columnForTrial('target', trialRow);
  targetContent = replaceVariables(targetContent, undefined, undefined, undefined, 1);
  stimContainers[0].innerHTML = targetContent;

  wordHeight = $('#word1').height();
  wordBorder = parseInt($("#word2").css("border-left-width"),10);

  if(columnForTrial('stimOptions', trialRow).includes('random')){
    randomizeStimOrder(stimContainers);
  }

  console.log('stimContainers init', stimContainers);
  console.log('many screens? ', trialHasManyScreens(listTrialScreensTimings[trialRow]));

  // FOR SIMULTANEOUS PRESENTATION
  if (!trialHasManyScreens(listTrialScreensTimings[trialRow]))
  {
		console.log('single words screen');

      //// CFPT /////////////////
      if (columnForTrial('test', trialRow) == "CFPT") {
        //for now do these only for CFPT
        showCFPT();
      }
      if (columnForTrial('test', trialRow) == "CFPT2") {
        showCFPT2();
      }

    // SHOW TARGET
    if (columnForTrial('target', trialRow) != "na") {
      stimContainers[0].style.width = width1word + "px";
      stimContainers[0].style.top = (canvasHeight/2 - 3*wordHeight/2 - spaceTargetWords) + "px";
      stimContainers[0].style.left = (canvasWidth/2 - width1word/2) + "px";
      stimContainers[0].style.display = "block";
    }

    // start time presTime_ms
    window.screenViewStart = performance.now();
    console.info('[debug_actual] ' +window.screenViewStart);

    // SHOW TEST
    if (columnForTrial('test', trialRow) != "CFPT" && columnForTrial('test', trialRow) != "CFPT2") {
      window.minImagesTop = showWordTest(listNoStim[trialRow]);
    }

    var trialTextOptions = columnForTrial('trialTextOptions', trialRow);

    if (trialTextOptions == 'na' || trialTextOptions == 'allTrial'){
      showTrialText(listArrays[allColumns.indexOf('trialText')][trialRow]);
    }

    displayText("topLeft", replaceVariables(listArrays[allColumns.indexOf('topLeft')][trialRow], undefined, undefined, undefined, 1));
    displayText("topRight", replaceVariables(listArrays[allColumns.indexOf('topRight')][trialRow], undefined, undefined, undefined, 1));

    timeInMs = performance.now(); //record time


    /// HIDE WORDS
    if(!isNaN(listTrialScreensTimings[trialRow][0].presTime) && listArrays[allColumns.indexOf('test')][trialRow]!="CFPT" && columnForTrial('presTime', trialRow) != "na")
    {
      var tmpTime = performance.now();
      console.info('[debug_actual] start postpone (display completed) ${'+tmpTime+'} - delta ' + (tmpTime - window.screenViewStart));
      eventTimeOutS1 = postpone(function(info) {
        hideTargetAndTest();
        window.recordPresTime(info);
        var tmpTime2 =  performance.now();
        var pTimeActual = tmpTime2 - tmpTime;
        console.info('[debug_actual] end postpone ${'+tmpTime2+'} delta '+ pTimeActual);
        // multiple key responses
        var trialOptions = window.listTrialResponseOptions[window.trialRow] || {};
        var shouldRecordMultipleKeys = Boolean(trialOptions.multipleResponses);
        // if we have multiple keys to record and we recorded the maximum required, then we can move to the next trial
        if (shouldRecordMultipleKeys && window.trialKeysPressedCounter >= trialOptions.multipleResponses.max) {
          nextTrialWithKeys(window.keysTrial);
          return;
        }

        // presentation time finished, but did not reach minimum yet, will end once minimum is reached
        if(shouldRecordMultipleKeys){
          trialOptions.multipleResponses.presentationFinished = true;
        }

        enableResponseWindowAfterStim(trialRow);
        hideTextAfterLastStim(trialRow);
        // showTrialTextAfterStim(trialRow);
        //self-advancing for learning
        if (columnForTrial('type', trialRow) == "learn") {
          autoAdvance();
        }
      }, listTrialScreensTimings[trialRow][0].presTime, window.lastTs);
      window.lastPresPostponeIndex = eventTimeOutS1;
    }

    //all events at once as we have only one screen
    enableResponseWindowAtTrialStart(trialRow);
    enableResponseWindowWithStim(trialRow);
    enableResponseWindowLastStim(trialRow);
  }

  //FOR SEQUENTIAL PRESENTATION
  else
  {
    enableResponseWindowAtTrialStart(trialRow);
    // WITH TARGET
    if (columnForTrial('target', trialRow)!="na")
    {
        stimContainers[0].style.width = width1word + "px";
        stimContainers[0].style.top = (canvasHeight/2 - 3*wordHeight/2 - spaceTargetWords) + "px";
        stimContainers[0].style.left = (canvasWidth/2 - width1word/2) + "px";
        stimContainers[0].style.display="block";
    }

    verticalShift = 0;
    displayScreen2();
  }
}

function disableWordClicks(i){
  if(!stimContainers[i].id){
    return;
  }

  if(stimContainers[i].id.indexOf("word") > -1){
    stimContainers[i].className="word";
    $(stimContainers[i]).off("click");
  }
}

function enableWordClicks(i){
  if(stimContainers[i].id.indexOf("word") > -1){
    stimContainers[i].className="word clickableWord";
  }
}